<app-navbar-style-one></app-navbar-style-one>

<div class="menu-page account-section">
    <div class="container-fluid">
        <div class="content-wrapper">
            <!-- Left Image -->
            <div class="left-image">
                <img src="../../../assets/img/home2/header1.jpg" alt="Chef seasoning steak">
            </div>

            <!-- Center Content -->
            <div class="center-content">
                <h2>{{ 'Order apps' | titlecase}}</h2>
                <p>
                    Here’s your order so far! Double-check your dishes, adjust portions, or add something tasty before you checkout
                </p>
            </div>

            <!-- Right Images -->
            <div class="right-images">
                <img src="../../../assets/img/home2/header3.jpg" alt="Stuffed mushroom dish">
                <img src="../../../assets/img/home2/header2.jpg" alt="Gourmet burger with fries">
            </div>
        </div>
    </div>
</div>

<!-- <section class="orderAppsSection mt-2">
    <div class="container-fluid px-3">
        <div class="row" *ngIf="!isLoading">
            <div class="col-lg-4 col-md-6 col-sm-6 col-12 pt-3 text-center" *ngFor="let item of orderApps;let i = index">
                <div class="customCard">
                    <div class="text-center m-auto" style="width: 250px;height: 250px;">
                        <img [src]="item.image" [alt]="item.title" class="img-fluid" alt="Apps">
                    </div>
                    <a [href]="item.url" target="_blank" class="btn btn-primary">{{item.title}}</a>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="isLoading">
            <div class="col-12 text-center">
                <div class="spinner-grow" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    </div>
</section> -->

<div class="container-custom">
    <div class="row" *ngIf="!isLoading">
        <!-- Card 1 -->
        <div class="col-lg-3 col-md-6 col-sm-6" *ngFor="let item of orderApps;let i = index">
            <div class="uber-card">
                <div class="logo-container">
                    <div class="text-center m-auto" style="width: 200px;height: 200px;">
                        <a [href]="item.url" target="_blank">
                            <img [src]="item.image" [alt]="item.title" class="img-fluid" alt="Apps">
                        </a>
                    </div>
                </div>
                <div class="card-footer-text px-0">
                    <h5><a [href]="item.url" target="_blank" class="btn btn-primary">{{item.title}}</a></h5>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="isLoading">
        <div class="col-12 text-center">
            <div class="spinner-grow" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>